import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {};

export const BreakDownReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.EDIT_BREAKDOWN:
      return { ...state, ...payload };

    case ActionTypes.OPEN_OR_CLOSE_BREAKDOWNPOPUP:
      return {
        ...state,
        setOpen: payload,
      };

    case ActionTypes.CLOSE_EDIT_BREAKDOWN_POPUP:
      return {
        ...state,
        setEditBreakDown: payload,
      };

    default:
      return state;
  }
};
